import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const WA_NUMBER = '6287786556067';

export default function Footer() {
  return (
    <footer className="bg-primary text-white">
      {/* Main Footer */}
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <AppLogo size={44} />
              <div>
                <div className="font-extrabold text-white text-xl leading-tight">NAYVERA</div>
                <div className="text-accent text-xs font-semibold tracking-widest uppercase">Indo Transport</div>
              </div>
            </div>
            <p className="text-white/65 text-sm leading-relaxed mb-5">
              Solusi transportasi profesional untuk setiap perjalanan. Armada terawat, driver berpengalaman, dan layanan 24 jam.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-accent/20 border border-white/10 hover:border-accent/40 flex items-center justify-center transition-all duration-200"
                aria-label="Instagram"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-accent/20 border border-white/10 hover:border-accent/40 flex items-center justify-center transition-all duration-200"
                aria-label="Facebook"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href={`https://wa.me/${WA_NUMBER}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-green-500/20 border border-white/10 hover:border-green-500/40 flex items-center justify-center transition-all duration-200"
                aria-label="WhatsApp"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
  		<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.198-.497.099-.198-.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
		</svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-white text-sm uppercase tracking-widest mb-5">Menu</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Home', href: '/' },
                { label: 'Armada', href: '/fleet-armada-page' },
                { label: 'Layanan', href: '/layanan-page' },
                { label: 'Booking', href: '/booking-page' },
                { label: 'Galeri', href: '/galeri-page' },
                { label: 'Tentang Kami', href: '/tentang-kami-page' },
                { label: 'Kontak', href: '/kontak-page' },
              ]?.map((item) => (
                <li key={`footer-${item?.href}`}>
                  <Link
                    href={item?.href}
                    className="text-white/60 hover:text-accent text-sm transition-colors duration-200"
                  >
                    {item?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Armada */}
          <div>
            <h4 className="font-bold text-white text-sm uppercase tracking-widest mb-5">Armada</h4>
            <ul className="space-y-2.5">
              {[
                'Toyota Avanza', 'Toyota Innova Reborn', 'Toyota Alphard',
                'Toyota Hiace Commuter', 'Elf Long 19 Seat',
                'Medium Bus 31 Seat', 'Big Bus 50 Seat', 'Mitsubishi Pajero',
              ]?.map((vehicle) => (
                <li key={`footer-vehicle-${vehicle}`}>
                  <Link
                    href="/fleet-armada-page"
                    className="text-white/60 hover:text-accent text-sm transition-colors duration-200"
                  >
                    {vehicle}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-white text-sm uppercase tracking-widest mb-5">Kontak</h4>
            <ul className="space-y-4">
              <li className="flex gap-3">
                <MapPin size={16} className="text-accent shrink-0 mt-0.5" />
                <span className="text-white/65 text-sm leading-relaxed">
                  Jl. Atang Sanjaya No.Rt 01, RT.002/RW.005, Benda, Kec. Benda, Kota Tangerang, Banten 15125
                </span>
              </li>
              <li className="flex gap-3">
                <Phone size={16} className="text-accent shrink-0 mt-0.5" />
                <a
                  href={`https://wa.me/${WA_NUMBER}`}
                  className="text-white/65 hover:text-accent text-sm transition-colors"
                >
                  +62 877-8655-6067
                </a>
              </li>
              <li className="flex gap-3">
                <Mail size={16} className="text-accent shrink-0 mt-0.5" />
                <a
                  href="mailto:info@nayveraindotransport.com"
                  className="text-white/65 hover:text-accent text-sm transition-colors"
                >
                  info@nayveraindotransport.com
                </a>
              </li>
              <li className="flex gap-3">
                <Clock size={16} className="text-accent shrink-0 mt-0.5" />
                <span className="text-white/65 text-sm leading-relaxed">
                  Senin – Minggu<br />
                  24 Jam / 7 Hari
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/45 text-xs">
            © 2026 NAYVERA INDO TRANSPORT. Semua hak dilindungi.
          </p>
          <p className="text-white/45 text-xs">
            Rental Mobil Jakarta & Tangerang — Armada Premium dengan Driver Profesional
          </p>
        </div>
      </div>
    </footer>
  );
}